export enum HttpStatusCodeEnum {
  Unauthorized = 401,
  Forbidden = 403,
  Unable_Process = 422,
  ServerError = 500,
}
